import React, { useState } from 'react';
import Box from '@tds/core-box';
import StepTracker from '@tds/core-step-tracker';
import { useTranslation } from 'react-i18next';

import Container from '../../components/Container';
import Form from '../../components/Form';

const RegistrationForm = () => {
  const [t] = useTranslation();
  const [step, setStep] = useState(0);

  return (
    <Container>
      <Box>
        <StepTracker
          copy="en"
          current={step}
          steps={[t('STEP_1'), t('STEP_2'), t('STEP_3')]}
        />
      </Box>
      <Box between={3}>
        <Form step={step} setStep={setStep} />
      </Box>
    </Container>
  );
};

export default RegistrationForm;
